/* 🤖 this file was generated by svg-to-ts */
export const mgcIconDropCuteFi: {
  name: 'drop-cute-fi';
  data: string;
} = {
  name: 'drop-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.52 2.325c-1.14.081-2.096.543-3.02 1.461-.761.756-2.142 2.534-2.899 3.733-1.986 3.145-2.514 6.035-1.602 8.77.422 1.263 1.085 2.324 2.057 3.293.731.728 1.306 1.142 2.22 1.598.751.375 1.477.608 2.384.767.566.099 2.114.099 2.68 0 .907-.159 1.633-.392 2.384-.767.908-.453 1.515-.891 2.239-1.616A8.2 8.2 0 0 0 20 16.29c.913-2.735.387-5.615-1.6-8.771-.741-1.177-2.14-2.979-2.9-3.733-1.155-1.148-2.326-1.578-3.98-1.461"/></svg>`
};
